module.exports = __webpack_public_path__ + "static/media/sportsCar.128611a3.svg";